import {gql} from '@apollo/client'

export type QueryResult = {
  client: {
    id: string
    employee: {
      id: string
      employeeDocumentContractRequest: {
        id: string
        documents: Document[]
      }
    }
  }
}

type Document = {
  id: string
  title: string
}

export type QueryVariables = {
  employeeId: string
  requestId: string
}

export const CONTRACT_DOCUMENTS = gql`
  query contractDocuments($employeeId: ID!, $requestId: ID!) {
    client {
      id
      employee(employeeId: $employeeId) {
        id
        employeeDocumentContractRequest(requestId: $requestId) {
          id
          documents {
            id
            title
          }
        }
      }
    }
  }
`

export const DELETE_EMPLOYEE_DOCUMENT_CONTRACT = gql`
  mutation deleteEmployeeDocumentContract($input: DeleteEmployeeDocumentContractInput!) {
    deleteEmployeeDocumentContract(input: $input) {
      employeeDocumentContractRequest {
        id
        contractInfo {
          title
          senderName
          senderOfficeName
          comment
          status
          downloadableSignedDocument
          contractOriginalSenderInfo
        }
      }
    }
  }
`
